// extracted by mini-css-extract-plugin
export var current = "paginationDynamic-module--current--gmxHf";
export var disabled = "paginationDynamic-module--disabled--tAGN2";
export var dots = "paginationDynamic-module--dots--sZRch";
export var next = "paginationDynamic-module--next--2M8RT";
export var pagination = "paginationDynamic-module--pagination--0dcNG";
export var paginationInner = "paginationDynamic-module--paginationInner--a7fs4";
export var prev = "paginationDynamic-module--prev--C2VSI";
export var sbShowMain = "paginationDynamic-module--sb-show-main--kwfFV";